import { alpha, Theme } from '@mui/material';
import { useBlendColors } from 'hooks/useDesign';

export default {
    dialog: {
        zIndex: (theme: Theme) => theme.zIndex.appBar + 5,
        '.MuiDialog-paper': {
            overflow: 'visible',
            marginTop: '100px',
            alignSelf: 'flex-start',
        },
    },
    wrapper: {
        maxHeight: '442px',
        overflow: 'hidden',
    },
    searchHolder: {
        py: '11px',
        px: 1,
        flexShrink: 0,
        borderBottom: (theme: Theme) => `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
    },
    searchField: {
        '.MuiInput-root': {
            border: 0,
            boxShadow: 'none !important',
        },
        input: { fontSize: '14px' },
    },
    searchStartAdornmentBackButton: {
        display: 'inline-flex',
        alignItems: 'center',
        backgroundColor: (theme: Theme) => alpha(theme.palette.text.primary, 0.08),
        borderRadius: '3px',
        px: '6px',
        py: '1px',
        color: 'text.primary',
        minHeight: '20px',
        '&:hover': {
            cursor: 'pointer',
            opacity: 0.75,
        },
    },
    searchStartAdornmentBackButtonIcon: {
        fontSize: '16px',
        mr: '6px',
        display: 'inline-flex',
    },
    searchStartAdornment: {
        color: 'primary.main',
        fontSize: '16px',
        display: 'inline-flex',
    },
    searchEndAdornment: {
        border: (theme: Theme) => `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
        backgroundColor: (theme: Theme) => alpha(theme.palette.text.primary, 0.04),
        display: 'flex',
        alignItems: 'center',
        color: (theme: Theme) => alpha(theme.palette.text.primary, 0.64),
        lineHeight: '20px',
        px: 0.5,
        borderRadius: '3px',
        '.svg-icon-mi': {
            fontSize: '10px',
            mr: '2px',
        },
    },
    resultContainer: {
        overflow: 'auto',
    },
    emptyResult: {
        py: '11px',
        px: 2,
        backgroundColor: (theme: Theme) => alpha(theme.palette.text.primary, 0.04),
    },
    headingElement: {
        borderBottom: (theme: Theme) => `1px solid ${alpha(theme.palette.text.primary, 0.04)}`,
        backgroundColor: (theme: Theme) => useBlendColors(alpha(theme.palette.text.primary, 0.04)),
        color: (theme: Theme) => alpha(theme.palette.text.primary, 0.64),
        py: '7px',
        px: 2,
        fontSize: '11px',
        lineHeight: '18px',
        position: 'sticky',
        top: 0,
        zIndex: 1,
    },
    resultElement: {
        alignItems: 'center',
        minHeight: '40px',
        px: 2,
        py: '6px',
        '&.active': {
            backgroundColor: (theme: Theme) => alpha(theme.palette.primary.main, 0.04),
            '.command-menu-action-holder': {
                visibility: 'visible',
            },
        },
    },
    resultElementIcon: {
        display: 'inline-flex',
        width: '16px',
        height: '16px',
    },
    resultElementContent: {
        flexGrow: 1,
        py: '1px',
    },
    resultElementLabel: {},
    resultElementDesc: {
        mt: '2px',
        color: (theme: Theme) => alpha(theme.palette.text.primary, 0.8),
    },
    resultElementActionHolder: {
        visibility: 'hidden',
    },
    resultElementActionButton: {
        pl: 1,
        pr: 1.5,
        height: '28px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'primary.main',
        border: (theme: Theme) => `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
        borderRadius: '3px',
        backgroundColor: 'background.default',
        flexShrink: 0,
        '&.action-icon': {
            px: '5px',
        },
        '&.active': {
            borderColor: (theme: Theme) => theme.palette.primary.main,
        },
        '&.clickable:hover': {
            borderColor: (theme: Theme) => theme.palette.primary.main,
            backgroundColor: (theme: Theme) => alpha(theme.palette.primary.main, 0.08),
            opacity: 0.7,
            cursor: 'pointer',
        },
    },
    resultElementActionButtonIcon: {
        fontSize: '16px',
        display: 'inline-flex',
    },
};
